import BaseResource        from '@/lib/data/resource/BaseResource'
import dayjs from 'dayjs'

export default class RiskActiveEveAnalysisResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    const p = payload || {}

    /* ----------------- Base Currency ----------------- */
    this.baseCurrency = {
      symbol           : p.baseCurrency?.symbol ?? '',
      displayName      : p.baseCurrency?.displayName ?? '',
      displaySymbol    : p.baseCurrency?.displaySymbol ?? '',
      name             : p.baseCurrency?.name ?? '',
      supportedFeatures: p.baseCurrency?.supportedFeatures ?? []
    }

    this.result = {
      regulatoryThresholds: p.result?.regulatoryThresholds ?? {},
      internalThresholds  : p.result?.internalThresholds ?? {},
      baselTests          : p.result?.baselTests ?? {},
      historicalEveChanges: p.result?.historicalEveChanges ?? {},
      sharpestEveChanges  : p.result?.sharpestEveChanges ?? {}
    }

    this.AnalysisName = p.analysisName ?? ''
    this.ValueDate = p.valueDate ?? ''
    this.ValueDateFmt = this.getDateFmt(this.ValueDate)
  }

  static fromApiResponse (payload) {
    return new RiskActiveEveAnalysisResource(payload)
  }

  getDateFmt (date) {
    return date ? dayjs(date).format('MMMM DD, YYYY') : ''
  }
}
